import { render, staticRenderFns } from "./Qyjbxx.vue?vue&type=template&id=90c55fca&scoped=true&"
import script from "./Qyjbxx.vue?vue&type=script&lang=js&"
export * from "./Qyjbxx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c55fca",
  null
  
)

export default component.exports